export default __webpack_public_path__ + "static/jigsaw-2e82b3083573c860797e34da062502ff.png";